__turbopack_context__.v({
  "root": "ReadMoreHTML-module-scss-module__s1ofIa__root",
});
